<template>
  <b-modal
    id="history"
    size="lg"
    centered
    hide-footer
    hide-header
    class="p-0"
    no-close-on-backdrop
    :visible="showModal"
    @hidden="hideFeedbackhistory()"
  >
    <b-overlay :show="showSpinner">
      <div class="newpanlog-rs-mainhead-1">
        <div>View Feedback History</div>
        <div @click="hideFeedbackhistory()">
          <img
            class="rotate-on-hover xmark-pos-his"
            src="../../../assets/panelist/blue_cross.svg"
            alt=""
          />
        </div>
      </div>
      <hr class="hr-jd-his" />

      <div
        class="vc-body-fd mt-3"
        v-if="feedbackHistory.length != 0 && !showSpinner"
      >
        <div
          v-for="(i, index) in feedbackHistory"
          :key="index + 'feedback'"
          class="vc-card-container mt-3"
        >
          <div
            @click.stop="toggleCollapse(index)"
            class="padding-12-20"
            :class="[
              index === activeIndex ? 'vc-open-card' : 'vc-close-card',
              'pointer',
            ]"
          >
            <div class="vc-black-txt w-60 text-truncate">
              <span
                v-b-tooltip.hover="
                  i.interviewRoundObj.id != 'F' ? i.interviewRoundObj.name : ''
                "
              >
                {{
                  i.interviewRoundObj.id == "F"
                    ? "Final Round"
                    : i.interviewRoundObj.name
                }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <div class="vc-darkgrey-txt mr-3">{{ i.formatedDate }}</div>
              <img
                v-if="!collapsedIndexes[index]"
                class="pointer"
                src="../../../assets/panelLog/down_arrow.svg"
                alt=""
              />
              <img
                v-else
                class="pointer"
                src="../../../assets/panelLog/dpd_open.svg"
                alt=""
              />
            </div>
          </div>
          <b-collapse v-model="collapsedIndexes[index]">
            <div class="p-3">
              <b-row :key="index + 'row1'">
                <b-col cols="4">
                  <div
                    class="
                      pff-add-left-main-headings
                      d-flex
                      align-items-center
                      h-100
                    "
                  >
                    {{ i.recommendation == "NI" ? "Recruiter" : "Panel Name" }}
                  </div>
                </b-col>
                <b-col cols="8">
                  <div class="vc-input-modal d-flex align-items-center">
                    <b-form-input
                      v-model="i.panelName"
                      :disabled="true"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <b-row :key="index + 'row2'" class="mt-3">
                <b-col cols="4">
                  <div
                    class="
                      pff-add-left-main-headings
                      d-flex
                      align-items-center
                      h-100
                    "
                  >
                    Action
                  </div>
                </b-col>
                <b-col cols="8">
                  <div class="vc-input-modal d-flex align-items-center">
                    <b-form-input
                      :placeholder="
                        showRecOptions && i.feedbackText
                          ? i.feedbackText
                          : i.recommendation == 'R'
                          ? 'Rejected'
                          : i.recommendation == 'H'
                          ? 'On-Hold'
                          : i.recommendation == 'NI'
                          ? 'Not Interested'
                          : i.recommendation == 'DNA'
                          ? 'No Show'
                          : i.awaitingForApproval == '0' &&
                            i.recommendation == 'F'
                          ? 'Approval pending from BU Head'
                          : i.recommendation == 'S' ||
                            i.recommendation == 'FS' ||
                            i.recommendation == 'F'
                          ? 'Selected'
                          : ''
                      "
                      :disabled="true"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <b-row :key="index + 'row3'" class="mt-3">
                <b-col cols="4">
                  <div class="pff-add-left-main-headings d-flex h-100">
                    Remarks
                  </div>
                </b-col>
                <b-col cols="8">
                  <div class="vc-input-modal d-flex align-items-center">
                    <b-form-textarea
                      v-model="i.recruiterRemarks"
                      :disabled="true"
                      rows="4"
                      max-rows="6"
                      style="overflow: auto"
                    ></b-form-textarea>
                  </div>
                </b-col>
              </b-row>
              <!-- for bot analysis -->
              <div
                class="divider"
                v-if="i.botInfo && i.botInfo.botAnalysisCompleted"
              ></div>
              <section
                v-if="
                  i.botInfo &&
                  i.botInfo.botAnalysisCompleted &&
                  i.botInfo.botSummary
                "
              >
                <div>
                  <h5
                    class="
                      fw-500
                      fs-14
                      font-mont
                      color-344054
                      d-flex
                      align-items-center
                    "
                  >
                    Interview Summary
                    <img
                      src="@/assets/img/botanalysis/hire3xai.svg"
                      class="ml-2"
                      alt=""
                    />
                  </h5>
                </div>
                <p class="mt-2 fs-14 fw-500 font-mont color-darkblack">
                  {{ i.botInfo.botSummary }}
                </p>
              </section>

              <b-row>
                <!-- <div
                  v-if="i.panelFeedbackForm != null"
                  class="d-flex justify-content-end w-100 mr-3 pointer"
                >
                  <div
                    class="d-flex pointer"
                    @click="downloadFeedback(i.panelFeedbackForm)"
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="../../../assets/panelLog/download_fdfm.svg"
                    />
                    <div class="fdbk-his-link">Feedback Form</div>
                  </div>
                </div> -->
                <div
                  class="d-flex justify-content-end w-100 mt-3 mr-3"
                  v-if="
                    !i.botInfo ||
                    i.botInfo.botAnalysisCompleted == false ||
                    i.botInfo.botAnalysisCompleted == null
                  "
                >
                  <div
                    class="d-flex pointer"
                    @click.stop="assignfilledvalues(i)"
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="../../../assets/panelLog/preview_eye.svg"
                    />
                    <div class="fdbk-his-link">Feedback Form</div>
                  </div>
                </div>
                <!-- bind justify-content-between gap-15 when bot analysis is there or justify-content-center -->
                <div
                  v-else-if="i.botInfo && i.botInfo.botAnalysisCompleted"
                  class="
                    mt-3
                    d-flex
                    justify-content-between
                    gap-15
                    align-items-center
                    w-100
                    mx-3
                  "
                >
                  <div
                    @click="goToBotAnalysis(i.interviewID, index)"
                    v-if="roles.includes('VIEW_CANDIDATE_ANALYSIS')"
                    class="
                      d-flex
                      w-100
                      bg-mainblue
                      viewpanel-fdbck
                      pointer
                      justify-content-center
                    "
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="@/assets/img/botanalysis/botanalysis.svg"
                    />
                    <div class="color-white fw-600 fs-13 font-mont">
                      View Bot Analysis
                    </div>
                  </div>
                  <div
                    class="
                      d-flex
                      viewpanel-fdbck
                      w-100
                      pointer
                      justify-content-center
                    "
                    @click.stop="assignfilledvalues(i)"
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="../../../assets/panelLog/preview_eye.svg"
                    />
                    <div class="color-mainblue fw-600 fs-13 font-mont">
                      View Panel Feedback
                    </div>
                  </div>
                </div>
              </b-row>
            </div>
          </b-collapse>
        </div>
      </div>
      <div
        v-else-if="feedbackHistory.length == 0 && !showSpinner"
        class="modal-ht mt-5 pt-4 pr-5"
      >
        <div class="d-flex justify-content-center align-items-center">
          <img class="" src="../../../assets/panelist/nofeedback.svg" alt="" />
        </div>
        <div class="mt-3 text-center nofeedback-txt">
          Feedback is not provided for this Candidate.
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div
          class="
            d-flex
            align-items-center
            justify-content-end
            w-100
            border-top
            bluebtn
            pt-3
            pb-1
            pl-4
            pr-4
          "
        >
          <b-button class="acs-cancelBtn-modal" @click="hideFeedbackhistory()"
            >Close</b-button
          >
        </div>
      </div>
      <PreviewFeedback
        v-if="ipmodal"
        :selectedRound="passData"
        :candidateData="candidateData"
        :basicCandInfo="candidateDetails"
        :allData="allData"
        :ipmodal="ipmodal"
        :showScreenshot="true"
        :fromHistory="true"
        @closeModal="closeModal"
      />
    </b-overlay>
  </b-modal>
</template>
<script>
// import TotalMark from "../../../controllers/vendorCode/modals/TotalMark.vue";
import { downloadFeedback } from "../../../utils/download.js";

import { getFeedbackHistory } from "../../../utils/apiFunctions";
import PreviewFeedback from "../../../views/InterviewProcess/PreviewFeedback.vue";
import { mapGetters } from "vuex";

export default {
  name: "History",
  props: {
    showModal: Boolean,
    candidateID: String,
    candidateData: Object,
    jobID: String,
  },
  components: {
    PreviewFeedback,
  },

  data() {
    return {
      allData: {},
      feedbackHistory: [],
      collapsedIndexes: [],
      ipmodal: false,
      showSpinner: false,
      activeIndex: null,
      passData: {},
      candidateDetails: {},
      vccollapse: false,

      marksdetails: {},
      dummy: {},
    };
  },
  created() {
    this.showSpinner = true;
    this.getFeedBackHistory();
  },
  computed: {
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters({ roles: "roles" }),
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
  },
  methods: {
    goToBotAnalysis(interviewID, index) {
      let queryData = {
        intid: interviewID,
        type: 1,
        fromkanban: true,
        fromPage: this.$route.name,
        candidateID: this.candidateID,
        round: index,
      };
      queryData = {
        ...queryData,
        ...this.$route.query,
      };
      delete queryData.preview;
      this.$emit("storeCandidateData");
      this.$router.push({
        name: "BotAnalysis",
        query: queryData,
      });
    },
    async getFeedBackHistory() {
      const res = await getFeedbackHistory({
        candidateID: this.candidateID,
        jobID: this.jobID,
      });
      if (res.status == 200) {
        this.feedbackHistory = res.data.data;
        for (var data in this.feedbackHistory) {
          this.collapsedIndexes[data] = false;
          this.feedbackHistory[data].formatedDate = this.formatTimestamp(
            this.feedbackHistory[data].createdAt
          );
        }
        let index = this.$route.query.round ? this.$route.query.round : 0;
        this.collapsedIndexes[index] = true;
        this.activeIndex = parseInt(index);
        this.showSpinner = false;
      }
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      const day = days[date.getDay()];
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = String(date.getMinutes()).padStart(2, "0");
      const ampm = hour >= 12 ? "PM" : "AM";
      const formattedHour = hour % 12 || 12;

      return `${formattedHour}:${minute} ${ampm} ${day}, ${month} ${date.getDate()}, ${year}`;
    },
    hideFeedbackhistory() {
      this.$emit("hideFeedbackhistory");
      this.$store.commit("jobDescriptionVUEX/setSelectedCandidate", "");
      if (this.$route.query.feedbackModal) {
        let newQuery = { ...this.$route.query };
        delete newQuery.round;
        delete newQuery.feedbackModal;
        delete newQuery.candidateID;

        this.$router.replace({ path: this.$route.path, query: newQuery });
      }
      this.ipmodal = false;
      this.activeIndex = null;
      this.collapsedIndexes = [];
      this.feedbackHistory = [];
    },
    closeModal() {
      this.ipmodal = false;
    },
    toggleCollapse(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
      this.collapsedIndexes = this.collapsedIndexes.map((value, idx) =>
        idx === index ? !value : false
      );
    },
    downloadFeedback(url) {
      downloadFeedback(url);
    },
    assignfilledvalues(data) {
      this.ipmodal = true;
      this.passData = data.customFeedback;
      this.candidateDetails = data.customFeedback.basicInfo;
      this.candidateDetails.feedback = data.assessmentResponse;
      this.allData = data;
    },
  },
};
</script>

<style>
.viewpanel-fdbck {
  padding: 9px 24px;
  border: 1px solid #20639b;
  border-radius: 23px;
}
</style>
